var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","value-format":"yyyy-MM-dd","placeholder":_vm.placeholder},on:{"change":_vm.change},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }